import { FilestoreAPI } from '@builddocs/filestore-api'

export interface GetDocstoreFiltersRequest {
  section: string
  filter: 'owners' | 'organizations'
  projectId: string
}

export function getDocstoreFilters({
  section,
  filter,
  projectId,
}: GetDocstoreFiltersRequest) {
  return FilestoreAPI.post(
    `/${section.toLowerCase().replace('_', '')}/${projectId}/search-${filter}`,
  ).then(r => r.data)
}
